// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32d392f5","239":"5b8d67e0","667":"3230a6ba"}[chunkId] + ".chunk.js";
};